// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"styles_sectionContent__S6RfL","mediaWrapper":"styles_mediaWrapper__KvgZN","image":"styles_image__EI8VO","list":"styles_list__qGSWq","item":"styles_item__WC_RM"};